import React, {Component} from 'react'

class AppStoreBadge extends Component{
    constructor(props){
        super(props)
    }

    _onPress = () => {
        var url = 'https://apps.apple.com/us/app/flocks/id1340904970';
        var win = window.open(url, '_blank');
        win.focus();
    }
    render(){
        return(
            <div style={{ margin: '00px',  display: 'flex'}}>
                <div style={this._style.badge} onClick={()=>this._onPress()}/>
            </div>
        )
    }

    _style = ({
        badge: {
            display: 'flex',
            justifyContent: 'center',
            overflow: 'hidden',
            cursor: 'pointer',
            background: 'url(https://linkmaker.itunes.apple.com/assets/shared/badges/en-us/appstore-lrg.svg) no-repeat',
            width: '135px',
            height: '40px',
            backgroundSize: 'contain',
        }
    })
}

export default AppStoreBadge